import Vue from "vue";
import { setupAxios } from "@/axios";
import Notifications from "vue-notification";
import VModal from "vue-js-modal";
import Tooltip from "vue-directive-tooltip";
import VueIntercom from "vue-intercom";
import TextareaAutosize from "vue-textarea-autosize";
import i18n from "./i18n";
import VueHead from "vue-head";
import GAuth from "vue-google-oauth2";
import mixpanel from "mixpanel-browser";
import Clipboard from "v-clipboard";
import VueCardFormat from "vue-credit-card-validation";
import Rollbar from "rollbar";
import { Kochava } from "kochava";
import PortalVue from "portal-vue";
import VueDatePicker from "@mathieustan/vue-datepicker";

// local styles must be last style import
import App from "./App.vue";
import IconToastClose from "@/components/icons/IconToastClose";
import IconToastExclamation from "@/components/icons/IconToastExclamation";
import router from "./router";
import store from "./store";
import "./assets/style/style.scss";

Vue.use(Notifications);
Vue.use(TextareaAutosize);
Vue.component("close-toast", IconToastClose);
Vue.component("exclamation-toast", IconToastExclamation);
Vue.use(VModal);
Vue.use(Tooltip);
Vue.use(VueIntercom, { appId: process.env.VUE_APP_INTERCOM_APP_ID });
Vue.use(Clipboard);

Vue.use(VueHead, {
  separator: "",
  complement: ""
});

Vue.use(VueCardFormat);

mixpanel.init(process.env.VUE_APP_MIXPANEL_PROJECT_TOKEN, {});

Vue.prototype.$mixpanel = mixpanel;

const kochava = Kochava.createForVue();

kochava.startWithAppGuid(process.env.VUE_APP_KOCHAVA_APP_ID);

Vue.prototype.$kochava = kochava;

const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_APP_ID_DEV,
  scope: "profile email",
  prompt: "select_account"
};

Vue.use(GAuth, gauthOption);

setupAxios(Vue);

Vue.config.productionTip = false;

Vue.prototype.$rollbar = new Rollbar({
  accessToken: process.env.VUE_APP_ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: process.env.VUE_APP_ROLLBAR_ENV,
  payload: {
    code_version: "1.0.0",
    custom_data: "client_web"
  }
});

Vue.config.errorHandler = (err, vm) => {
  vm.$rollbar.error(err);
  throw err;
};

Vue.use(PortalVue);

// @mathieustan/vue-datepicker ships only en, fr, es, de, he, ru and sv. With no
// lang configured, every one of its components derives one from
// navigator.language, and for a language it does not ship its getLocale() calls
// itself with the same unresolvable code forever — "Maximum call stack size
// exceeded". The birthday picker then renders nothing at all and its bordered
// wrapper collapses to a 2px line, which reads as a stray underline.
//
// This has to be set globally rather than as a `locale` prop on the picker: the
// prop reaches only its root component, while the nested ones (VDPickerTableDay
// and friends) resolve their own locale and keep recursing.
//
// Arabic is not among the shipped locales, so it cannot be selected here either;
// Arabic month names would need a complete custom locale object, which the
// library validates key by key.
Vue.use(VueDatePicker, { lang: "en" });

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount("#app");
